import Flickity from 'flickity';

export default class PartnershipSpotlight {
  constructor() {
    this.$els = document.querySelectorAll('.js-partnership-spotlight');

    this.$els.forEach($el => {
      const $carousel = $el.querySelector('.js-partnership-spotlight-carousel');
      const $prevbutton = $el.querySelector('.js-partnership-spotlight-prev');
      const $nextbutton = $el.querySelector('.js-partnership-spotlight-next');

      const carousel = new Flickity($carousel, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        imagesLoaded: true,
      });

      if ($prevbutton) {
        $prevbutton.addEventListener('click', () => {
          carousel.previous();
        });
      }

      if ($nextbutton) {
        $nextbutton.addEventListener('click', () => {
          carousel.next();
        });
      }
    })
  }
}
